import { FC } from 'react';

import { styled } from '@/stitches.config';
import { Box } from '@base-app';
import { ReactComponent as Check } from '@assets/icons/check.svg';
import { DropdownListItemProps } from './Dropdown.types';
import { DropdownListItemStyled } from './Dropdown.styles';

const StyledCheckIcon = styled(Check, {
  height: '$4',
  width: '$4',
});

const DropdownListItem: FC<DropdownListItemProps> = ({ item, isSelected, selected, selectableMode, onClick }) => {
  return (
    <DropdownListItemStyled
      data-testid={'dropdown-ul'}
      onClick={onClick}
      className={selected === true ? 'selected' : ''}
    >
      <Box
        as="span"
        data-testid={`dropdown-${item.id}`}
        css={{
          fontWeight: isSelected ? '$bold' : '$normal',
        }}
      >
        {item.label}
      </Box>
      {selectableMode === true && selected === true && (
        <Box
          as="span"
          css={{
            alignContent: 'normal',
            paddingLeft: '$3',
            position: 'relative',
            top: '2px',
          }}
        >
          <StyledCheckIcon />
        </Box>
      )}
    </DropdownListItemStyled>
  );
};

export default DropdownListItem;
